import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  NO_ERRORS_SCHEMA
} from "@angular/core";
import {
  distinct,
  filterBy,
  FilterDescriptor,
} from "@progress/kendo-data-query";
import { FilterService } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { CommonModule } from "@angular/common";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { InputsModule, KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_LABEL, LabelModule } from "@progress/kendo-angular-label";
import moment from 'moment';
import { LoggerService } from "../../shared/logger.service";
import { AutoFocusDirective } from "../../directives/auto-focus.directive";

@Component({
  selector: 'multicheck-filter',
  standalone: true,
  imports: [
    CommonModule,
    ButtonsModule,
    InputsModule,
    LabelModule,
    AutoFocusDirective,
    KENDO_LABEL,
    KENDO_INPUTS
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './multicheck-filter.component.html',
  styleUrl: './multicheck-filter.component.scss'
})
export class MulticheckFilterComponent implements AfterViewInit {
  @Input() public isPrimitive: boolean = true;
  @Input() public currentFilter: CompositeFilterDescriptor = { logic: "and", filters: [] };
  @Input() public data: any[] = [];
  @Input() public textField = '';
  @Input() public valueField = '';
  @Input() public filterService: FilterService = new FilterService();
  @Input() public field: string = '';
  @Input() public includeTime: boolean = false; //for dates
  @Output() public valueChange = new EventEmitter<number[]>();

  public currentData: unknown[] = [];
  public showFilter = true;
  private value: unknown[] = [];

  public textAccessor = (dataItem: unknown): string => {
    if (typeof dataItem === 'string') {
      // if (moment(dataItem, true).isValid())
      if (dataItem.length > 4 && moment(dataItem, true).isValid()) {
        if (this.includeTime) 
          return moment(dataItem).format('DD/MM/YYYY HH:mm');
        else 
          return moment(dataItem).format('DD/MM/YYYY');
      }
        
      else
        return dataItem;
    }
    else
      return this.isPrimitive ? (dataItem as string) : (dataItem as any)[this.textField];
  }

  public valueAccessor = (dataItem: unknown): unknown =>
    this.isPrimitive ? dataItem : (dataItem as any)[this.valueField];


  constructor(
    private logger: LoggerService
  ) {
  }

  public ngAfterViewInit(): void {
    // this.logger.debug('ngAfterViewInit...', this.data, this.currentFilter);
    this.currentData = this.data;
    this.value = this.currentFilter.filters.map(
      f => {
        // this.logger.debug('ngAfterViewInit: f ==>>', f)
        return (f as FilterDescriptor).value;
      }
      // (f: FilterDescriptor) => <FilterDescriptor>f.value
    );

    this.showFilter =
      typeof this.textAccessor(this.currentData[0]) === "string";
  }
  public isItemSelected(item: unknown): boolean {
    return this.value.some((x) => x === this.valueAccessor(item));
  }
  public onSelectionChange(item: unknown, li: HTMLLIElement): void {
    if (this.value.some((x) => x === item)) {
      this.value = this.value.filter((x) => x !== item);
    } else {
      this.value.push(item);
    }

    this.filterService.filter({
      filters: this.value.map((value) => ({
        field: this.field,
        operator: value === null ? "isnull" : "eq",
        value,
      })),
      logic: "or",
    });

    this.onFocus(li);
  }

  public onInput(e: Event): void {
    // let argh = this.data.filter((dataItem) => {
    //     if (moment(dataItem as string, true).isValid()) {
    //       let mod = moment(dataItem as string, true).format('DD/MM/YYYY');
    //       return mod.indexOf((e.target as HTMLInputElement).value) != -1
    //     }
    //     else return false;
    // });
    this.currentData = distinct(
      [
        ...this.currentData.filter((dataItem) =>
          this.value.some((val) => val === this.valueAccessor(dataItem))
        ),
        ...this.data.filter((dataItem) => { //for dates have data as string in 'YYYY-MM-DD' format so should sort correctly. A Date object would be better for sort but doesn't work well with matching string in filter menu
          if (dataItem && moment(dataItem as string, true).isValid()) {
            let mod = moment(dataItem as string, true).format('DD/MM/YYYY');
            return mod.indexOf((e.target as HTMLInputElement).value) != -1
          }
          else return false;
        }),
        ...filterBy(this.data, {
          operator: "contains",
          field: this.textField,
          value: (e.target as HTMLInputElement).value,
        }),
      ],
      this.textField
    );
  }

  public onFocus(li: HTMLLIElement): void {
    const ul = li.parentNode as HTMLUListElement;
    const below =
      ul.scrollTop + ul.offsetHeight < li.offsetTop + li.offsetHeight;
    const above = li.offsetTop < ul.scrollTop;

    // Scroll to focused checkbox
    if (above) {
      ul.scrollTop = li.offsetTop;
    }

    if (below) {
      ul.scrollTop += li.offsetHeight;
    }
  }

}
